// extracted by mini-css-extract-plugin
export var button = "index-module--button--HVv8P";
export var buttonContainer = "index-module--buttonContainer--a4F7S";
export var container = "index-module--container--tA13G";
export var discountTag = "index-module--discountTag--UspC9";
export var divider = "index-module--divider--XGcZn";
export var imageContainer = "index-module--imageContainer--elfMR";
export var shortDescription = "index-module--shortDescription--+-s2Z";
export var specification = "index-module--specification--FXHAS";
export var specifications = "index-module--specifications--s+qeA";
export var specificationsContainer = "index-module--specificationsContainer---yK7H";
export var title = "index-module--title--oKGy4";